import {
  INIT_SDK,
  APPLY_LIST,
  SESSION_LIST,
  FRIEND_LIST,
  CHAT_LIST,
  SEND_CHAT,
  SEND_APPLY,
  SEND_AGREE,
  SEND_REJECT,
  SEND_ADD_HEALTH_DATA,
  INIT_NETCALL,
  INIT_NETCON
} from './mutation-type'        
const SDK = require('SDK')
export const Netcall = require('Netcall')

export default {
//--------------------------------SDK初始化，注册监听-----------------------------
  [INIT_SDK](state, {
    account,
    token
  }) {
    state.nim = new SDK.NIM({
        // 初始化SDK
        debug: false,
        appKey: '027c85232797c251aef236e68191730f',
        account: account,
        token: token,
        onconnect: onConnect,
        onerror: onError,
        onwillreconnect: onWillReconnect,
        ondisconnect: onDisconnect,
        // 多端登录
        onloginportschange: onLoginPortsChange,
        // 用户关系

        // 好友关系
        onfriends: onFriends,
        // 消息
        onroamingmsgs: onRoamingMsgs,
        onofflinemsgs: onOfflineMsgs,
        onmsg: onmsg,
        //系统通知
        oncustomsysmsg: onCustomSysMsg
    });
    function onmsg(message){
        // alert(JSON.stringify(message));
        console.log(message)

        // 自定义通知
        if(/notification/i.test(message.type)){
          // 取出消息体
          const content = message.attach
          // 判断消息体类型
          if(/netcallBill/i.test(content.type)) {
            console.log('话单通话双方账号：', content.accounts)
            console.log('话单通话时长：' + content.duration + ' 秒');
            state.callTime=content.duration+'秒';
          }
        }
    }

    function onConnect() {
      console.log('连接成功');
    }

    function onWillReconnect(obj) {
      // 此时说明 `SDK` 已经断开连接, 请开发者在界面上提示用户连接已断开, 而且正在重新建立连接
      console.log('即将重连');
      console.log(obj.retryCount);
      console.log(obj.duration);
    }

    function onDisconnect(error) {
        // 此时说明 `SDK` 处于断开状态, 开发者此时应该根据错误码提示相应的错误信息, 并且跳转到登录页面
        console.log('丢失连接');
        console.log(error);
        if (error) {
            switch (error.code) {
            // 账号或者密码错误, 请跳转到登录页面并提示错误
            case 302:
                break;
            // 被踢, 请提示错误后跳转到登录页面
            case 'kicked':
                break;
            default:
                break;
            }
        }
    }

    function onError(error) {
      console.log(error);
    }

    function onLoginPortsChange(loginPorts) {
      console.log('当前登录帐号在其它端的状态发生改变了', loginPorts);
    }


    function onFriends(friends) {
      console.log('收到好友列表', friends);
    }

    function onRoamingMsgs(obj) {
      console.log('漫游消息', obj);
    }

    function onOfflineMsgs(obj) {
      console.log('离线消息', obj);
    }

    function onCustomSysMsg(sysMsg) {
        console.log('收到系统通知', sysMsg);
        if(sysMsg.content=="视频接通"||sysMsg.content=="完成问诊单！"){
            state.systemPhy=true;//发送问诊页面推送
        }
        else{
            var sys=JSON.parse(sysMsg.content);
            console.log(sys)
            if(sys.pushType=='cancelQueue'||sys.pushType=='inQueue'){
                state.systemCon=true;//收到会诊页面推送
                state.systemPhy=true;//发送问诊页面推送
                if(sys.pushType=='inQueue'){
                    openPlay();
                }
            }
            else if(sys.pushType=='remind'){
                state.remind=true;
                openPlay();
                console.log(state.remind)
                
            }
            else{
                state.systemPhy=true;//发送问诊页面推送
            }
        }
        
    }
    function openPlay(){
        var element = document.getElementsByTagName('audio')
        var msgElement = document.getElementById('message')
        
        if(element.length > 0) {
        msgElement.removeChild(element[0])
        }
        var audios = document.createElement('audio')
        audios.src = require('../service/gl.mp3')
        audios.autoplay = "autoplay"
        msgElement.appendChild(audios)
        
    }
},
    //===================================================================
    //-----------------音视频实例化、注册监听------------------------------
    [INIT_NETCALL](state, {
        meContainer,
        youContainer
    }){
        console.log(meContainer);
        console.log(youContainer);
        state.onLoad=true; 
        const Netcall = WebRTC;
        state.Netcall = Netcall
        //音视频相关配置
        var NIM = SDK.NIM;
            NIM.use(Netcall);
        var initConfig = {
            nim: state.nim,
            container: meContainer, //我的视频画面
            remoteContainer: youContainer, //对方的视频画面
            mirror: true,
            mirrorRemote: false,
            debug:false
        }
        
        state.netcall = Netcall.getInstance(initConfig);
        
        state.netcall.initSignal()
        .then(function () {
            console.log('signalInited');
            state.signalInited = true;
        })
        .catch(function (err) {
            console.log('initSignalError', err);
            state.signalInited = false;
        });

        // 当信令通道断开时, 会触发 signalClosed 事件
        state.netcall.on('signalClosed', function () {
            console.log('信令通道断开--------------------主动挂断视频----------------');
            state.signalInited = false;
            state.netcall.hangup();
            closeVideo(state.netcall,state.Netcall);
            console.log('视频信息中断')
        });

        // 初始化过程中会通过 devices 事件回传所有的设备列表
        state.netcall.on('devices', function (obj) {
            console.log('on devices', obj);
        });

        //开启监听，监听被叫事件
        state.netcall.on('beCalling', function (obj) {
            console.log('-------------有人呼叫你，视频啦----------------');
            console.log(obj);
            state.beCalledInfo=obj
            state.calling=true;
            state.video=true;
        });

        // 被叫接受的通知
        state.netcall.on('callAccepted', function(obj) {
            // 缓存呼叫类型，后面开启音视频连接需要用到
            // type = obj.type;
            console.log('---------对方已接受视频----------');

            //停止声音播放
            var audioEl=document.getElementById('audioPlay');
            audioEl.pause();

            // 取消呼叫倒计时
            clearTimeout(state.callTimer);
            state.beCalledInfo=obj;
            //关掉呼叫页面
            state.toCall=false;
            // 可以开启音视频连接操作。。。
            openVideo(meContainer,youContainer);
        });

        // 被叫拒绝的通知
        state.netcall.on('callRejected', function(obj) {
            console.log('-------------被叫拒绝--主动挂断视频----------------');
            // 取消呼叫倒计时
            clearTimeout(state.callTimer);
            // 挂断
            state.netcall.hangup();
            //关掉呼叫页面
            state.toCall=false;
            //视频被拒绝了
            state.called=true;
        });

        //开启监听，监听挂断事件
        state.netcall.on('hangup', function(obj) {
            console.log('--------视频被挂断--视频挂断监听事件----------', obj);

            //停止声音播放
            var audioEl=document.getElementById('audioPlay');
            audioEl.pause();
            
            // 判断需要挂断的通话是否是当前正在进行中的通话
            if (!state.beCalledInfo || state.beCalledInfo.channelId === obj.channelId) {
              // 清理工作
              closeVideo(state.netcall,state.Netcall)
            }
        });

        //开启视频流显示
        function openVideo(meContainer,youContainer){
            state.calling=false;
            state.consult=true;
            
            // let promise=null;
            const netcall = state.netcall;
            const Netcall=state.Netcall;
            
            // 连接媒体网关
            netcall.startRtc().then(function() {
                // 开启麦克风
                return netcall.startDevice({
                    type: Netcall.DEVICE_TYPE_AUDIO_IN
                }).catch(function(err) {
                    console.log('启动麦克风失败')
                    console.error(err)
                })
            })
            .then(function() {
                // 设置采集音量
                netcall.setCaptureVolume(255);
                console.log('开启摄像头')
                // 开启摄像头
                return netcall.startDevice({
                    type: Netcall.DEVICE_TYPE_VIDEO,
                    width: 850,
                    height: 850
                })
                .then(function(){
                    netcall.startLocalStream(meContainer);
                })
                .catch(function(err) {
                    console.log('启动摄像头失败')
                    console.error(err);
                })
            })
            .then(function() {
                // 设置本地预览画面大小
                netcall.setVideoViewSize({
                    width: 850,
                    height: 850,
                    cut:true
                })
            })
            .catch(function(err) {
                console.log('发生错误')
                console.log(err)
                netcall.hangup()
            })
            
            // 在回调里监听对方加入通话，并显示对方的视频画面
            netcall.on('remoteTrack', function(obj) {
                console.log('user join', obj)
                // 播放对方声音
                netcall.startDevice({
                    type: Netcall.DEVICE_TYPE_AUDIO_OUT_CHAT
                }).catch(function(err) {
                    console.log('播放对方的声音失败')
                    console.error(err)
                })
                // 预览对方视频画面
                netcall.startRemoteStream({
                    account: obj.account,
                    node: youContainer
                })
                // 设置对方预览画面大小
                netcall.setVideoViewRemoteSize({
                    account: obj.account,
                    width: 850,
                    height: 850,
                    cut:true
                })
            })
            state.showVideo=true;
           
        };
        function closeVideo(netcall,Netcall){
            state.calling=false;
            state.showVideo=false;
            state.video=false;
            // 停止本地视频预览
            netcall.stopLocalStream();

            // 停止对端视频预览
            netcall.stopRemoteStream();

            // 停止设备麦克风
            netcall.stopDevice(Netcall.DEVICE_TYPE_AUDIO_IN);

            // 停止设备摄像头
            netcall.stopDevice(Netcall.DEVICE_TYPE_VIDEO);

            // 停止播放本地音频
            netcall.stopDevice(Netcall.DEVICE_TYPE_AUDIO_OUT_LOCAL);

            // 停止播放对端音频
            netcall.stopDevice(Netcall.DEVICE_TYPE_AUDIO_OUT_CHAT);
        }
    },
    //视频接通后的网络监听
    [INIT_NETCON](state){
        const netcall = state.netcall;
        var detectType = state.Netcall.NETDETECT_AUDIO
        netcall.netDetect(detectType)
        .then(function(obj) {
            console.log('netDetect success', obj)
        })
        .catch(function(err) {
            console.log('netDetect error', err)
        })
    },
    beCalledInfo(state, data){
        console.log(data);
        state.beCalledInfo = data
    },
    toCall(state,data){
        state.toCall=data;
    },
    called(state,data){
        state.called=data;
    },
    showVideo(state,data){
        state.showVideo=data;
    },
    calling(state,data){
        state.calling=data;
    },
    video(state,data){
        state.video=data;
    },
    systemCon(state,data){
        state.systemCon=data;
    },
    systemPhy(state,data){
        state.systemPhy=data;
    },
    remind(state,data){
        state.remind=data;
    },
    onLoad(state,data){
        state.onLoad=data;
    },
    audioing(state,data){
        state.audioing=data;
    }
}




// WEBPACK FOOTER //
// ./src/store/mutations.js